import { Clock, ArrowRight } from "lucide-react";

export default function BlogCard({
  blog,
  baseUrlForFile,
  onReadMore
}) {
  return (
    <div className="whb-card">

      <div className="whb-card__inner">

        {/* IMAGE */}
        <div className="whb-card__img-wrap">
          <img
            src={`${baseUrlForFile}/${blog.image}`}
            alt={blog.blog_title}
            className="whb-card__img"
          />

          <span className="whb-date">
            <Clock size={12} />
            {blog.created_at}
          </span>
        </div>

        {/* BODY */}
        <div className="whb-card__body">

          <span className="whb-category">
            {blog.category || "Blog"}
          </span>

          <h3 className="whb-card__title">
            {blog.blog_title}
          </h3>

        <p className="blog-desc">
  {blog.description}
</p>

          {/* FOOTER */}
          <div className="whb-card__footer">
            <button
              className="whb-read-btn"
              onClick={() => onReadMore(blog)}
            >
              <span>Read More</span>
              <ArrowRight size={16} />
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}